import React, { createContext, useState, useContext, useCallback } from 'react';
import { cartAPI } from '../services/api';

const CartContext = createContext();

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) throw new Error('useCart debe usarse dentro de CartProvider');
  return context;
};

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState({ items: [], subtotal: 0, total_vu: 0, item_count: 0 });
  const [loading, setLoading] = useState(false);

  const loadCart = useCallback(async () => {
    setLoading(true);
    try {
      const res = await cartAPI.getCart();
      setCart(res.data);
    } catch {
      setCart({ items: [], subtotal: 0, total_vu: 0, item_count: 0 });
    } finally {
      setLoading(false);
    }
  }, []);

  const addItem = async (productId, quantity = 1, sttoraPackId = null) => {
    await cartAPI.addItem({ product_id: productId, quantity, sttora_pack_id: sttoraPackId });
    await loadCart();
  };
  const addPack = async (packId) => {
    await cartAPI.addItem({ product_id: null, sttora_pack_id: packId, quantity: 1 });
    await loadCart();
  };

  const updateItem = async (itemId, quantity) => {
    await cartAPI.updateItem(itemId, { quantity });
    await loadCart();
  };

  const removeItem = async (itemId) => {
    await cartAPI.removeItem(itemId);
    await loadCart();
  };

  const clearCart = () => {
    setCart({ items: [], subtotal: 0, total_vu: 0, item_count: 0 });
  };

  const value = { cart, loading, loadCart, addItem, addPack, updateItem, removeItem, clearCart };

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};
